import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { SimpleVDriveDeliveryEntity } from '../types/deliveries.types';
import type { SimpleLocationEntity } from '../types/location.types';

type DeliveriesState = {
  deliveries: SimpleVDriveDeliveryEntity[];
  setDeliveries: (value: SimpleVDriveDeliveryEntity[]) => void;

  vDriveLocations: SimpleLocationEntity[];
  setVDriveLocations: (value: SimpleLocationEntity[]) => void;

  hasNewDelivery: boolean;
  setHasNewDelivery: (value: boolean) => void;

  updateDelivery: (updatedDelivery: SimpleVDriveDeliveryEntity) => void;
};

export const useDeliveries = create<DeliveriesState>()(
  devtools(
    (set) => ({
      deliveries: [],
      setDeliveries: (value) => set(() => ({ deliveries: value })),

      vDriveLocations: [],
      setVDriveLocations: (value) => set(() => ({ vDriveLocations: value })),

      hasNewDelivery: false,
      setHasNewDelivery: (value) => set(() => ({ hasNewDelivery: value })),

      updateDelivery: (updatedDelivery) =>
        set((state) => {
          const index = state.deliveries.findIndex(
            (delivery) => delivery.id === updatedDelivery.id
          );
          if (index !== -1) {
            const updatedList = [...state.deliveries];
            updatedList[index] = updatedDelivery;
            return { deliveries: updatedList };
          }
          return {};
        }),
    }),
    { name: 'deliveries' }
  )
);
